<template>
  <div class="f14-l18 w-100 padding-20 margin-top-10" v-html="text"></div>
</template>
<script>
export default {
  props: {
    text: String
  }
}
</script>